/* eslint-disable camelcase */

import {
  ACTIVE_BUILDING_FRONTAGE,
  ACTIVE_BUILDING_FRONTAGE_VALUES,
  BUFFER_QUALITY,
  BUFFER_QUALITY_VALUES,
  BUFFER_WIDTH,
  BUFFER_WIDTH_VALUES,
  COMFORT_ZONE_WIDTH,
  COMFORT_ZONE_WIDTH_VALUES,
  CROSSING_IMPROVEMENTS,
  CROSSING_IMPROVEMENTS_VALUES,
  CROSSING_SPACING,
  CROSSING_SPACING_VALUES,
  HEAVY_VEHICLES,
  HEAVY_VEHICLES_VALUES,
  LANDSCAPE_BUFFER_STREET_TREES,
  LANDSCAPE_BUFFER_STREET_TREES_VALUES,
  LIGHTING,
  LIGHTING_VALUES,
  PEDESTRIAN_FACILITY_TYPE,
  PEDESTRIAN_FACILITY_TYPE_VALUES,
  PREVAILING_POSTED_SPEED,
  SIDEWALK_ACCESSIBILITY,
  SIDEWALK_ACCESSIBILITY_VALUES,
  SIDEWALK_QUALTIY,
  SIDEWALK_QUALTIY_VALUES,
  SPECIAL_CONSIDERATIONS,
  SPECIAL_CONSIDERATION_VALUES,
  USABLE_SIDEWALK_WIDTH,
  USABLE_SIDEWALK_WIDTH_VALUES
} from '../constants/pedestrian'

export const pedestrianConfig = [
  {
    name: 'Pedestrian Facility Type',
    id: PEDESTRIAN_FACILITY_TYPE,
    inputType: 'dropDown',
    required: true,
    inputValues: PEDESTRIAN_FACILITY_TYPE_VALUES,
    scores: null,
    notes:
      "This input is used to determine inputs below. It is not part of the evaluation criteria. 'No sidewalk' includes rural paved shoulders (with or without delineators). Detached sidewalk has a landscape, parking, or painted (e.g. bike lane) buffer between the sidewalk and auto travel lanes."
  },
  {
    name: 'Buffer Width',
    id: BUFFER_WIDTH,
    inputType: 'dropDown',
    scores: null,
    required: true,
    inputValues: BUFFER_WIDTH_VALUES,
    notes:
      'Buffer Width affects the score of prevailing posted speed and travel lanes.'
  },
  {
    name: 'Buffer Quality',
    id: BUFFER_QUALITY,
    inputType: 'dropDown',
    required: true,
    inputValues: BUFFER_QUALITY_VALUES,
    notes: 'Refers to any buffer between pedestrians and travel lanes.'
  },
  {
    name: 'Landscape Buffer and Street Trees',
    id: LANDSCAPE_BUFFER_STREET_TREES,
    inputType: 'dropDown',
    required: true,
    inputValues: LANDSCAPE_BUFFER_STREET_TREES_VALUES,
    notes: 'Choose continuity of landscaping or street trees.'
  },

  {
    name: 'Usable Sidewalk Width',
    id: USABLE_SIDEWALK_WIDTH,
    inputType: 'dropDown',
    required: true,
    inputValues: USABLE_SIDEWALK_WIDTH_VALUES,
    notes:
      'Width of the primary accessible pathway, also known as the through zone.'
  },
  {
    name: 'Sidewalk Quality',
    id: SIDEWALK_QUALTIY,
    inputType: 'dropDown',
    required: true,
    inputValues: SIDEWALK_QUALTIY_VALUES,
    notes: 'Quality of the pavement in the through zone.'
  },
  {
    name: 'Comfort Zone Width',
    id: COMFORT_ZONE_WIDTH,
    inputType: 'dropDown',
    required: true,
    inputValues: COMFORT_ZONE_WIDTH_VALUES,
    notes:
      'Comfort zone is the width of usable sidewalk or paved shoulder that is clear of utilities, sidewalk dining, and other obstructions'
  },
  {
    name: 'Sidewalk Accessibility',
    id: SIDEWALK_ACCESSIBILITY,
    inputType: 'dropDown',
    required: true,
    inputValues: SIDEWALK_ACCESSIBILITY_VALUES,
    notes:
      'How the sidewalk interacts with driveways, especially impacting those with accessibility needs.'
  },
  {
    name: 'Lighting',
    id: LIGHTING,
    inputType: 'dropDown',
    required: true,
    inputValues: LIGHTING_VALUES,
    notes: 'Level of lighting for pedestrians in the through zone.'
  },
  {
    name: 'Heavy Vehicles (Trucks)',
    id: HEAVY_VEHICLES,
    inputType: 'dropDown',
    required: true,
    inputValues: HEAVY_VEHICLES_VALUES,
    notes:
      'Choose percentage of vehicles that are trucks. Refer to local, County, or MDOT counts if available, or contact SEMCOG for heavy vehicle estimates from regional travel model. Heavy vehicles are defined as FHWA vehicle classifications 6-13 when using count data or 8-13 when using estimates from the SEMCOG travel model'
  },
  {
    name: 'Active Building Frontage',
    id: ACTIVE_BUILDING_FRONTAGE,
    inputType: 'dropDown',
    required: true,
    inputValues: ACTIVE_BUILDING_FRONTAGE_VALUES,
    notes:
      'Active frontages are ground floors that pedestrians can interact with, including but not limited to, shops, parks, restaurants, cafes, or other services.'
  },
  {
    name: 'Crossing Spacing',
    id: CROSSING_SPACING,
    inputType: 'dropDown',
    required: true,
    inputValues: CROSSING_SPACING_VALUES,
    notes:
      'Use the segment that represents the "weakest link" (or greatest spacing) if spacing varies by block'
  },
  {
    name: 'Special Considerations',
    id: SPECIAL_CONSIDERATIONS,
    inputType: 'checkBox',
    required: true,
    inputValues: SPECIAL_CONSIDERATION_VALUES,
    notes: 'Leave unchecked if not applicable'
  },
  {
    name: 'Crossing Improvements',
    id: CROSSING_IMPROVEMENTS,
    inputType: 'checkBox',
    required: true,
    inputValues: CROSSING_IMPROVEMENTS_VALUES,
    notes: 'Leave unchecked if not applicable'
  },
  {
    name: 'Roadway Speed (MPH)',
    id: PREVAILING_POSTED_SPEED,
    inputType: 'number',
    required: true,
    autoPopulated: true,
    notes: 'Value populated in project setup on previous page.'
  },
  {
    name: 'Number of Travel Lanes',
    id: 'travel_lanes',
    inputType: 'number',
    required: true,
    autoPopulated: true,
    notes: 'Value populated in project setup on previous page.'
  },
  {
    name: 'Pedestrian Tier',
    id: 'tier',
    inputType: 'string',
    required: true,
    scores: null,
    autoPopulated: true,
    notes: 'Value populated in project setup on previous page.'
  },
  {
    name: 'Land Use Context',
    id: 'land_use_context',
    inputType: 'string',
    required: true,
    scores: null,
    autoPopulated: true,
    notes: 'Value populated in project setup on previous page.'
  }
]
